module.exports = __webpack_public_path__ + "static/img/jixiao.cd1fa9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/jixiao.png
// module id = zIFC
// module chunks = 19